export class UpdateIndexField {
    constructor(indexFieldRepository) {
      this.indexFieldRepository = indexFieldRepository;
    }
  
    async execute(UpdateIndexFieldRequest) {
      return await this.indexFieldRepository.UpdateIndexField(UpdateIndexFieldRequest);
    }
  }